import { FormatCurrency } from "../../../common/Constants";
import CustomDownloadComponent from "../../../components/FileDownload/CustomDownloadComponent";
import UploadedDocuments from "../../../components/UploadedDocuments/Uploaded Documents";

const VehicleDetails = ({ ApplicationData, GetOwnerType }) => {
  const AddLabelToFile = (arr, value) => {

    return {
      label: value,
      files: arr,
    };
  };
  const VehicleInfo = ApplicationData?.vehicleInfo;



  return (
    <>
      {VehicleInfo?.flooring_product === "BODYONLY" ? (
        <section>
          {/* Application Preview */}
          {/* <h2 className="preview-heading">Application Preview</h2> */}
          <div className="preview-list-block">
            <div className="preview-list-group">
              <div className="preview-list">
                <h3>Vehicle Type:</h3>
                <p>Used Vehicle (BODY ONLY)</p>
              </div>
            </div>
          </div>

          <div className="preview-list-block">
            {/* <h2 className="preview-subheading">Vehicle Details</h2> */}
            <div className="preview-list-group">
              <div className="preview-list">
                <h3>Original Reg Date:</h3>
                <p>{VehicleInfo?.original_reg_date}</p>
              </div>
              <div className="preview-list">
                <h3>Y.O.M:</h3>
                <p>{VehicleInfo?.yom}</p>
              </div>
            </div>
            <div className="preview-list-group">
              <div className="preview-list">
                <h3>Intended Floor Amount:</h3>
                <p>${VehicleInfo?.intended_floor_amount}</p>
              </div>
              <div className="preview-list">
                <h3>Purchase Price:</h3>
                <p>${VehicleInfo?.purchase_price}</p>
              </div>
              <div className="preview-list">
                <h3>Flooring Percentage:</h3>
                <p>{VehicleInfo?.flooring_percentage}%</p>
              </div>
            </div>
            <div className="preview-list-group">
              <div className="preview-list">
                <h3>Engine No:</h3>
                <p>{VehicleInfo?.engine_no}</p>
              </div>
              <div className="preview-list">
                <h3>Chassis No:</h3>
                <p>{VehicleInfo?.chassis_no}</p>
              </div>
            </div>
            <div className="preview-list-group">
              <div className="preview-list">
                <h3>Vehicle Status:</h3>
                <p>{GetOwnerType("vehicle_status", VehicleInfo?.vehicle_status)}</p>
              </div>
              <div className="preview-list">
                <h3>VAC Ready?:</h3>
                <p>{GetOwnerType("is_VAC_ready", VehicleInfo?.is_VAC_ready)}</p>
              </div>
              {VehicleInfo?.VAC_number !== undefined && (
                <div className="preview-list">
                  <h3>VAC Number</h3>
                  <p>{VehicleInfo?.VAC_number}</p>
                </div>
              )}

            </div>
          </div>

          {/* Uploaded Documents */}
          <div className="preview-list-block">
            <div className="download-block">
              <h2 className="preview-subheading">Document (s) Uploaded</h2>
              <CustomDownloadComponent type="Flooring-Vehicle-Details" appId={ApplicationData?.vehicleInfo?.id} formType={`BODYONLY`} />
            </div>
            <div className="preview-list-group">
              {ApplicationData?.v5_overseas_logcard?.length > 0 && (

                <UploadedDocuments
                  documents={AddLabelToFile(ApplicationData?.v5_overseas_logcard, "V5/Overseas Logcard")}
                />
              )}

              {ApplicationData?.sales_agreement?.length > 0 && (

                <UploadedDocuments
                  documents={AddLabelToFile(ApplicationData?.sales_agreement, "Sales Agreement")}
                />
              )}
              {ApplicationData?.letter_of_newness?.length > 0 && (

                <UploadedDocuments
                  documents={AddLabelToFile(ApplicationData?.letter_of_newness, "Letter of Newness")}
                />
              )}
              {ApplicationData?.data_card?.length > 0 && (

                <UploadedDocuments
                  documents={AddLabelToFile(ApplicationData?.data_card, "Data Card")}
                />
              )}
              {ApplicationData?.cargo_clearance_permit?.length > 0 && (

                <UploadedDocuments
                  documents={AddLabelToFile(ApplicationData?.cargo_clearance_permit, "Cargo Clearance Permit")}
                />)}
              {ApplicationData?.bill_of_landing?.length > 0 && (

                <UploadedDocuments
                  documents={AddLabelToFile(ApplicationData?.bill_of_landing, "Bill of Landing (BL)")}
                />
              )}
              {ApplicationData?.additional?.length > 0 && (
                <UploadedDocuments
                  documents={AddLabelToFile(ApplicationData?.additional, "Additional")}
                />
              )}
            </div>
          </div>
        </section>
      ) : (
        <section>
          {/* Application Preview */}
          <div className="preview-list-block">
            <div className="preview-list-group">
              <div className="preview-list">
                <h3>Vehicle Type:</h3>
                <p>
                  Used Vehicle (
                  {VehicleInfo?.flooring_product === "BODYONLY"
                    ? "BODY ONLY"
                    : VehicleInfo?.flooring_product}
                  )
                </p>
              </div>
              <div className="preview-list">
                <h3>Vehicle Reg No:</h3>
                <p>{VehicleInfo?.vehicle_reg_no}</p>
              </div>
              <div className="preview-list">
                <h3>Access Code:</h3>
                <p>{VehicleInfo?.access_code}</p>
              </div>
              <div className="preview-list">
                <h3>Make/Model:</h3>
                <p>{VehicleInfo?.make_model}</p>
              </div>
            </div>
            <div className="preview-list-group">
              <div className="preview-list">
                <h3>First Reg Date:</h3>
                <p>{VehicleInfo?.first_reg_date}</p>
              </div>
              <div className="preview-list">
                <h3>Y.O.M:</h3>
                <p>{VehicleInfo?.yom}</p>
              </div>
              <div className="preview-list">
                <h3>OPC Vehicle:</h3>
                <p>{VehicleInfo?.is_opc_vehicle == 0 ? "NO" : "YES"}</p>
              </div>
              <div className="preview-list">
                <h3>Intended Floor Amount:</h3>
                <p>${VehicleInfo.intended_floor_amount.slice(
                  0,
                  VehicleInfo.intended_floor_amount.indexOf(".")
                )}</p>
              </div>
            </div>
            <div className="preview-list-group">
              <div className="preview-list">
                <h3>Purchase Price:</h3>
                <p>${VehicleInfo?.purchase_price.slice(
                  0,
                  VehicleInfo.purchase_price.indexOf(".")
                )}</p>
              </div>
              <div className="preview-list">
                <h3>Flooring Percentage:</h3>
                <p>{VehicleInfo?.flooring_percentage}%</p>
              </div>
              <div className="preview-list">
                <h3>COE Expiry:</h3>
                <p>{VehicleInfo[`COE_expiry`]}</p>
              </div>
              {/* <div className="preview-list">
                <h3>COE-QP / PQP Paid:</h3>
                <p>{VehicleInfo[`COE_value`].slice(
                  0,
                  VehicleInfo.COE_value.indexOf(".")
                )}</p>
              </div> */}
              <div className="preview-list">
                <h3>COE-QP / PQP Paid:</h3>
                <p>
                  {VehicleInfo?.COE_value
                    ? String(VehicleInfo.COE_value).split(".")[0] // safer than slice+indexOf
                    : ""}
                </p>
              </div>
            </div>
            <div className="preview-list-group">
              <div className="preview-list">
                <h3>OMV:</h3>
                <p>${VehicleInfo?.OMV.slice(
                  0,
                  VehicleInfo.OMV.indexOf(".")
                )}</p>
              </div>
              <div className="preview-list">
                <h3>Engine No:</h3>
                <p>{VehicleInfo?.engine_no}</p>
              </div>
              <div className="preview-list">
                <h3>Chassis No:</h3>
                <p>{VehicleInfo?.chassis_no}</p>
              </div>
              <div className="preview-list">
                <h3>ARF Paid:</h3>
                <p>${VehicleInfo?.min_parf.slice(
                  0,
                  VehicleInfo.min_parf.indexOf(".")
                )}</p>
              </div>
            </div>
            <div className="preview-list-group">
            </div>
            <div className="preview-list-group">
              <div className="preview-list">
                <h3>COE Expiring?</h3>
                <p>{GetOwnerType("is_vehicle_coe_expiry", VehicleInfo?.is_vehicle_coe_expiry)}</p>
              </div>
              <div className="preview-list">
                <h3>COE Rebate:</h3>
                <p>${FormatCurrency(VehicleInfo?.coe_rebate)}</p>
              </div>
              <div className="preview-list">
                <h3>PARF Rebate:</h3>
                <p>${FormatCurrency(VehicleInfo?.parf_rebate)}</p>
              </div>
              <div className="preview-list">
                <h3>Total Rebate:</h3>
                <p>${FormatCurrency(VehicleInfo?.total_rebate)}</p>
              </div>
              <div className="preview-list">
                <h3>Remark:</h3>
                <p>{(ApplicationData?.cart?.[0]?.agent?.agent_other_conditions)}</p>
              </div>
            </div>
          </div>

          {/* Uploaded Documents */}
          <div className="preview-list-block">
            <div className="download-block">
              <h2 className="preview-subheading">Document (s) Uploaded</h2>
              <CustomDownloadComponent type="Flooring-Vehicle-Details" appId={ApplicationData?.vehicleInfo?.id} formType={`${ApplicationData?.vehicleInfo?.flooring_product}`} />
            </div>
            <div className="preview-list-group">
              {ApplicationData?.logcard?.length > 0 && (
                <UploadedDocuments
                  documents={AddLabelToFile(ApplicationData?.logcard, "Logcard Document(s)")}
                />
              )}
              {ApplicationData?.additional?.length > 0 && (
                <UploadedDocuments
                  documents={AddLabelToFile(ApplicationData?.additional, "Additional")}
                />
              )}
            </div>
          </div>
        </section>
      )}
    </>
  );
};
export default VehicleDetails;
